import React, { FC } from "react";
import cx from "classnames";
import { useTranslation } from "i18n";
import { dataTestIds } from "data-testids";
import { ISubscription } from "../../../types";
import Section from "../../Section";
import { Button } from "../../../../../Atoms/Button/Button";

interface Props {
  subscriptions: ISubscription[];
  selectedSubscriptionId?: string;
  selectSubscription: (subscription: ISubscription) => void;
}

const CDSubscriptionBlock: FC<React.PropsWithChildren<Props>> = ({
  subscriptions,
  selectedSubscriptionId,
  selectSubscription,
}) => {
  const { t } = useTranslation();

  return (
    <Section title={t("common:billing.section.membership")} isOpen>
      <div className="flex flex-col gap-[10px]">
        {subscriptions.map((subscription) => {
          const isSelected = subscription.id === selectedSubscriptionId;
          const textColorCondition = { "text-white": isSelected };

          return (
            <div
              className={cx(
                "border-grey-medium-3 flex max-w-[690px] cursor-pointer rounded-[10px] border-[1px] p-[10px] md:gap-5",
                {
                  "bg-color-brand-two": isSelected,
                  ...textColorCondition,
                }
              )}
              key={subscription.id}
              onClick={() => selectSubscription(subscription)}
              data-testid={
                dataTestIds.componentLibrary[
                  "Organisms.Billing.CDCheckout.CDSubscriptionBlock"
                ]
              }
            >
              <div className="flex flex-col md:flex-row">
                <div className="flex flex-col">
                  <div className="mb-[10px] text-xl font-semibold">
                    {subscription.name}
                  </div>
                  <div
                    className={cx(
                      "text-m text-color-neutral-one leading-5",
                      textColorCondition
                    )}
                  >
                    {subscription.description}
                  </div>
                </div>
                <div
                  className="flex flex-row items-center gap-[10px] md:flex-col md:items-end md:gap-0"
                  data-testid={
                    dataTestIds.componentLibrary[
                      "Organisms.Billing.CDCheckout.CDSubscriptionBlock.SubcriptionPrice"
                    ]
                  }
                >
                  <div className="text-xl font-semibold md:mb-[10px]">
                    {subscription.total}
                  </div>
                  <div
                    className={cx(
                      "text-m text-color-neutral-one whitespace-nowrap leading-5",
                      textColorCondition
                    )}
                  >
                    ({subscription.amount} + {t("common:billing.label.vat")})
                  </div>
                </div>
              </div>
              <div>
                <Button
                  text={
                    isSelected
                      ? t("common:button.label.selected")
                      : t("common:button.label.choose")
                  }
                  type="primary"
                  size="small"
                  data-testid={
                    dataTestIds.componentLibrary[
                      "Organisms.Billing.CDCheckout.CDSubscriptionBlock.chooseButton"
                    ]
                  }
                  className={cx("focus:text-color-brand-two py-0", {
                    "text-color-brand-two border-none bg-white hover:bg-white":
                      isSelected,
                  })}
                />
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default CDSubscriptionBlock;
